export const TIDS = {
  // Marketing
  marketingCtaHero: "hero-cta-button",
  marketingCtaFinal: "final-cta-button",
  marketingNavSignup: "nav-signup-btn",
  marketingNavLogin: "nav-login-btn",

  // Auth
  loginEmail: "login-email",
  loginPassword: "login-password",
  loginSubmit: "login-submit-btn",
  signupName: "signup-name",
  signupEmail: "signup-email",
  signupPassword: "signup-password",
  signupSubmit: "signup-submit-btn",
  logoutBtn: "logout-btn",

  // Dashboard
  dashRoot: "dashboard-root",
  kpiUpcoming: "kpi-upcoming",
  kpiRegistrations: "kpi-registrations",
  kpiAttendance: "kpi-attendance",
  kpiRevenue: "kpi-revenue",

  // Webinar
  webinarNewBtn: "webinar-new-btn",
  webinarSubmit: "webinar-submit-btn",
  webinarTitle: "webinar-title-input",
  webinarDesc: "webinar-desc-input",
  webinarDate: "webinar-date-input",
  webinarPrice: "webinar-price-input",
  webinarTags: "webinar-tags-input",
  webinarCopyLink: "webinar-copy-link-btn",
  webinarPublish: "webinar-publish-btn",

  // Public
  publicRegisterCta: "public-register-cta",
  publicRegisterName: "public-reg-name",
  publicRegisterEmail: "public-reg-email",
  publicRegisterWhatsapp: "public-reg-whatsapp",
  publicRegisterCity: "public-reg-city",
  publicRegisterSubmit: "public-reg-submit-btn",
  publicPayNow: "public-pay-now-btn",
  problemPill: "problem-pill",

  // AI
  aiKindSelect: "ai-kind-select",
  aiTopicInput: "ai-topic-input",
  aiGenerateBtn: "ai-generate-btn",
  aiOutput: "ai-output",

  // Custom Domains
  domainAddInput: "domain-add-input",
  domainAddBtn: "domain-add-btn",
  domainVerifyBtn: "domain-verify-btn",
  domainDeleteBtn: "domain-delete-btn",
  domainRow: "domain-row",
  domainUpgradeCta: "domain-upgrade-cta",

  // Plans
  planCard: "plan-card",
  planSelectBtn: "plan-select-btn",
  currentPlanBadge: "current-plan-badge",

  // Live Q&A
  liveQuestionInput: "live-question-input",
  liveQuestionSubmit: "live-question-submit-btn",
  liveReactionBtn: "live-reaction-btn",
  liveQuestionCard: "live-question-card",
  liveAiSuggestBtn: "live-ai-suggest-btn",
  liveMarkAnsweredBtn: "live-mark-answered-btn",

  // Courses
  courseNewBtn: "course-new-btn",
  courseTitle: "course-title-input",
  courseDesc: "course-desc-input",
  coursePrice: "course-price-input",
  courseSubmit: "course-submit-btn",
  courseEnrollSubmit: "course-enroll-submit-btn",
  courseRow: "course-row",

  // Multi-language
  langToggle: "lang-toggle-btn",
  translateBtn: "translate-btn",

  // Landing Page Builder
  pageNewBtn: "page-new-btn",
  pageTitleInput: "page-title-input",
  templateCard: "template-card",
  pageCreateSubmit: "page-create-submit-btn",
  pageEditorRow: "page-editor-row",
  sectionCard: "section-card",
  sectionAddBtn: "section-add-btn",
  sectionDeleteBtn: "section-delete-btn",
  pagePublishToggle: "page-publish-toggle",
  pageAiPromptInput: "page-ai-prompt-input",
  pageAiGenerateBtn: "page-ai-generate-btn",

  // Credits
  creditPackCard: "credit-pack-card",
  creditPurchaseBtn: "credit-purchase-btn",
  creditBalance: "credit-balance",

  // Funnels
  funnelNewBtn: "funnel-new-btn",
  funnelNameInput: "funnel-name-input",
  funnelCreateBtn: "funnel-create-btn",
  funnelRow: "funnel-row",
  funnelAddStepBtn: "funnel-add-step-btn",
  funnelStepRow: "funnel-step-row",
  funnelDeleteStepBtn: "funnel-delete-step-btn",
  funnelActivateBtn: "funnel-activate-btn",
  funnelCopyLinkBtn: "funnel-copy-link-btn",

  // Payouts
  payoutsBankHolder: "payouts-bank-holder-input",
  payoutsBankAccount: "payouts-bank-account-input",
  payoutsBankIfsc: "payouts-bank-ifsc-input",
  payoutsBankPan: "payouts-bank-pan-input",
  payoutsBankUpi: "payouts-bank-upi-input",
  payoutsBankSaveBtn: "payouts-bank-save-btn",
  payoutsSummary: "payouts-summary-card",
  payoutsLedgerRow: "payouts-ledger-row",
  payoutsHistoryRow: "payouts-history-row",
  adminPayoutTriggerBtn: "admin-payout-trigger-btn",
  adminPayoutAmount: "admin-payout-amount-input",
  adminPayoutMethod: "admin-payout-method-select",
  adminPayoutReference: "admin-payout-reference-input",
};
